var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-box",style:({'height': `${_vm.height}px`})},[_c('img',{staticClass:"img",attrs:{"src":require('@/assets/imgs/workbench/bg_empty.svg')}}),_c('div',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }